/**
 * 蜂助手活动大都有从 url 上取参的习惯，并且，活动经常会进行多次跳转，且带不同的参
 * 通过此方法，将每次的参数存到 sessionStorage 中，并取出合并再次存储，这样能保证 search 是完整的
 * 另有将search每次合并然后跳转时携带，此方法亦可，但容易在第三方跳转时丢失，且有可能造成 search 过大导致http get 问题发生
 *
 * 所以这个文件将输出两个 search, 普通的search(当前search），或 storageSearch，即以上描述的 search
 *
 * 如何使用？
 *
 * import $search from '@/fzs-public/WindowSearch.js'
 * import { search, storageSearch } from '@/fzs-public/WindowSearch.js'
 *
 */
import qs from 'qs'
import { sessionStorage } from './webStorage/Storage.js'
import _ from 'lodash'

function getUrlSearch () {
  let queryString = window.location.search.slice(1)
  if (!queryString) {
    let search = window.location.href
    search = search.match(/\?(.+$)/)
    if (search && search.length) {
      search = search[1] || ''
      search = search.replace(/[?]+/g, '&')
      queryString = search.replace(/#\//, '')
    }
  }
  return qs.parse(queryString) || {}
}

const FZS_STORAGE_SEARCH = 'FZS_STORAGE_SEARCH'

function updateStorageSearch (data = '') {
  const queryObject = getUrlSearch()

  const sessionData = sessionStorage.get(FZS_STORAGE_SEARCH) || {}

  Object.assign(sessionData, queryObject)

  if (data && _.isPlainObject(data)) {
    Object.assign(sessionData, data)
  }

  sessionStorage.set(FZS_STORAGE_SEARCH, sessionData)

  return sessionData
}

function getStorageSearch () {
  return sessionStorage.get(FZS_STORAGE_SEARCH) || {}
}

updateStorageSearch()

const search = getUrlSearch()
const storageSearch = getStorageSearch()

export default search
export {
  search,
  storageSearch,
  getUrlSearch,
  getStorageSearch
}
